/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeriesValuesRequestSearchAfter
 */
export interface SeriesValuesRequestSearchAfter {
    /**
     * 
     * @type {boolean}
     * @memberof SeriesValuesRequestSearchAfter
     */
    finished: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesValuesRequestSearchAfter
     */
    token: string;
}

/**
 * Check if a given object implements the SeriesValuesRequestSearchAfter interface.
 */
export function instanceOfSeriesValuesRequestSearchAfter(value: object): value is SeriesValuesRequestSearchAfter {
    if (!('finished' in value) || value['finished'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function SeriesValuesRequestSearchAfterFromJSON(json: any): SeriesValuesRequestSearchAfter {
    return SeriesValuesRequestSearchAfterFromJSONTyped(json, false);
}

export function SeriesValuesRequestSearchAfterFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesValuesRequestSearchAfter {
    if (json == null) {
        return json;
    }
    return {
        
        'finished': json['finished'],
        'token': json['token'],
    };
}

export function SeriesValuesRequestSearchAfterToJSON(value?: SeriesValuesRequestSearchAfter | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'finished': value['finished'],
        'token': value['token'],
    };
}

